import { Stack, Text } from '@hotjar/hotsauce';
import { ArrayTranslation } from '@hotjar/translations';
import { useTranslation } from 'react-i18next';
import processingGraphic from '../../../../resources/images/processing-payment.svg';
import * as S from '../ProcessOrderContainer.styles';

export function ProcessingOrder(): JSX.Element {
  const { t } = useTranslation('checkout', { keyPrefix: 'process-order.processing' });

  return (
    <Stack spacing="x3" direction="column">
      <S.Image src={processingGraphic} alt="" />
      <Text as="h1" textType="header4">
        {t('title')}
      </Text>
      <div>
        <ArrayTranslation
          t={t}
          i18nKey="body"
          mapperFunction={(paragraph: string) => (
            <Text as="p" textType="body2" key={paragraph}>
              {paragraph}
            </Text>
          )}
        />
      </div>
    </Stack>
  );
}
